import React from 'react';
import { IView } from 'interfaces/common';
import { IRoles } from 'interfaces/roles.interface';

const OnboardingDetailsUserView: IView = {
  key: 'viewOnboardingDetailsUser',
  title: 'preonboardingTemplateUser.detailsUserView.title',
  roles: [IRoles.ADMINISTRATOR, IRoles.HR],
  view: React.lazy(() => import('./details-user')),
  path: '/dane-uzytkownika/:userId',
};

export default OnboardingDetailsUserView;
